const SimulationEvent = require("./SimulationEvent");
const {convertNumIntoRoom} = require("./helper/dailyCleaning");
const dailyCleaningCost = require("../../db/dailyCleaning.json");

class DailyCleaning extends SimulationEvent {
  constructor(elements, emit, events) {
    super();
    this.elements = elements;
    this.inputs = {
      number: 0,
      numberPerRoom: 0,
      room: "",
      option: false
    }
    this.emit = emit;
    this.events = events;
    this.totalCost = 0;
    this.init();
  }

  // 値（インプット）の変化の監視
  init() {
    super.triggerAll(this.elements);
    // 定員数の値が変化した時
    super.watch(this.elements.capacityEle, (e) => {
      if (this.inputs.numberPerRoom) {
        this.inputs = {
          ...this.inputs,
          number: parseInt(e.target.value),
          room: convertNumIntoRoom(e.target.value, this.inputs.numberPerRoom)
        }
      } else {
        this.inputs = {
          ...this.inputs,
          number: parseInt(e.target.value)
        }
      }
      if (this.inputs.room && this.inputs.option) {
        this.calcTotalCost();
      }
    })

    // 一部屋あたりの定員人数の値が変化した時
    super.watch(this.elements.numberPerRoomEle, (e) => {
      if (this.inputs.number) {
        this.inputs = {
          ...this.inputs,
          numberPerRoom: parseInt(e.target.value),
          room: convertNumIntoRoom(this.inputs.number, parseInt(e.target.value))
        }
      } else {
        this.inputs = {
          ...this.inputs,
          numberPerRoom: parseInt(e.target.value)
        }
      }

      if (this.inputs.room && this.inputs.option) {
        this.calcTotalCost();
      }
    })


    // 委託内容が変化した時
    const checkboxes = this.elements.optionsEle.querySelectorAll(".checkbox")
    for (const checkbox of Array.from(checkboxes)) {
      super.watch(checkbox, (e) => {
        if (e.target.value === "daily-cleaning") {
          this.inputs = {
            ...this.inputs,
            option: e.target.checked
          }

          if (!e.target.checked) {
            this.resetTotalCost();
          }

          if (this.inputs.room && this.inputs.option) {
            this.calcTotalCost();
          }

        }
      })
    }
  }

  setInputs({capacityEle, numberPerRoomEle, optionsEle}) {

    const option = optionsEle.indexOf("daily-cleaning") >= 0;
    this.inputs = {
      numberPerRoom: parseInt(numberPerRoomEle),
      number: parseInt(capacityEle),
      room: convertNumIntoRoom(capacityEle, parseInt(numberPerRoomEle)),
      option
    }


    if (this.inputs.room && this.inputs.option) {
      this.calcTotalCost();
    }
  }


  calcTotalCost() {

    const {num, hour, wage, day} = dailyCleaningCost.data[this.inputs.room];

    console.log('=== 日常清掃費 詳細計算 ===');
    console.log(`部屋区分: ${this.inputs.room}`);
    console.log(`定員数: ${this.inputs.number}人, 1部屋あたり定員: ${this.inputs.numberPerRoom}人`);
    console.log(`計算した部屋数: ${Math.ceil(this.inputs.number / this.inputs.numberPerRoom)}部屋`);
    console.log(`清掃員数: ${num}人`);
    console.log(`1日の清掃時間: ${hour}時間`);
    console.log(`時給: ${wage}円`);
    console.log(`月の稼働日数: ${day}日`);

    this.totalCost = num * hour * wage * day;
    console.log(`【日常清掃費 計算式】: ${num} × ${hour} × ${wage} × ${day} = ${this.totalCost}円`);
    console.log('========================');

    this.emit("dailyCleaning", this.totalCost);
  }

  resetTotalCost() {
    this.totalCost = 0;
    this.emit("dailyCleaning", this.totalCost);
  }

  getTotalCost() {
    if (!this.totalCost) return 0;
    return this.totalCost;
  }


}

module.exports = DailyCleaning;
